<div class="main-content">
    <div class="greeting">
        <span class="material-icons">account_circle</span>
        {{ "dashboard.hello" | translate }}, <strong>{{ username }}</strong>
    </div>

    <div class="dashboard-cards">
        <div class="password-card">
            <h2>{{ "dashboard.title" | translate }}</h2>
            <p>{{ "dashboard.explanatory" | translate }}</p>

            <div *ngIf="userPassFormVisible" class="password-form">
                <user-pass
                    [selectedUsername]="username"
                    (cancel)="cancelPasswordChange()">
                </user-pass>
            </div>

            <div *ngIf="isLoadingUserPassForm" class="spinner-container">
                <span class="spinner"></span>
            </div>

            <button
                class="btn-password"
                *ngIf="!userPassFormVisible && !isLoadingUserPassForm"
                (click)="showUserPassForm()">
                <span class="material-icons">lock_reset</span>
            </button>
        </div>
        <settings-panel></settings-panel>
        <versions></versions>
    </div>
</div>
